<template>
  <div class="map_section">
    <div id="map"></div>
  </div>
</template>

<script>
    export default {
      name: "Map"
    }
</script>

<style scoped>

</style>
